import React, { useState, useEffect, memo, useMemo } from "react";
import { LogOutIcon } from "lucide-react";
import md5 from "blueimp-md5";
import { Link } from "react-router-dom";
import { logout as logoutApi } from "../utils/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/authContext";

const MentorHeader = memo(function MentorHeader({ toggleSidebar, isMobile }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const { isMentorLoggedIn, mentor, loginMentor, logoutMentor } = useAuth();

  const fullName = useMemo(() => localStorage.getItem("mentorName") || "", []);
  const email = useMemo(() => localStorage.getItem("mentorEmail") || "", []);
  const mentorImage = useMemo(() => localStorage.getItem("mentorImage") || "", []);

  const avatarUrl = useMemo(() => {
    const emailVal = localStorage.getItem("email") || "";
    if (!emailVal) return "/avatar.png";

    const cachedAvatar = localStorage.getItem("cachedAvatar");
    if (cachedAvatar) return cachedAvatar;

    const normalizedEmail = emailVal.trim().toLowerCase();
    const hash = md5(normalizedEmail);
    const avatarUrl = `https://www.gravatar.com/avatar/${hash}?s=80&d=identicon`;
    localStorage.setItem("cachedAvatar", avatarUrl);
    return avatarUrl;
  }, []);

  const handleLogout = async () => {
    try {
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!showDropdown) return;

    const handleClickOutside = (event) => {
      const dropdown = document.getElementById("admin-profile-dropdown");
      const button = document.getElementById("admin-profile-button");

      if (dropdown && !dropdown.contains(event.target) && button && !button.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);


  return (
    <div
      className="
    sticky top-0 z-40
    bg-gradient-to-r from-[#020617] via-[#020617] to-[#0f172a]
    border-b border-white/10
    backdrop-blur-xl
    
  "
    >
      <div className="flex items-center justify-between px-4 md:px-6 py-3">

        {/* LEFT — Hamburger + Search */}
        <div className="flex items-center flex-1 gap-3">
          <button
            onClick={toggleSidebar}
            className="md:hidden text-slate-300 hover:text-white p-2 rounded-lg hover:bg-white/10 transition"
          >
            ☰
          </button>

          {/* Search */}
          <div className="flex items-center">
            <h1 className="text-base md:text-lg font-semibold text-slate-200 tracking-wide">
              TACTOS Mentor Dashboard
            </h1>
          </div>
        </div>

        {/* RIGHT — Profile */}
        <div className="relative flex items-center gap-3">

          <button
            onClick={() => setShowDropdown(v => !v)}
            className="flex items-center gap-2 p-1.5 rounded-xl hover:bg-white/10 transition"
          >
            <div className="h-8 w-8 rounded-lg overflow-hidden ring-1 ring-white/10">
              <img
                src={mentorImage || avatarUrl}
                alt="Profile"
                className="h-full w-full object-cover"
                onError={(e) => {
                  e.currentTarget.onerror = null
                  e.currentTarget.src = "/avatar.png"
                }}
              />
            </div>

            <div className="hidden sm:block text-left">
              <div className="text-sm font-medium text-slate-100">{fullName}</div>
              <div className="text-xs text-slate-400">Mentor</div>
            </div>

            <svg className="hidden sm:block w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Dropdown */}
          {showDropdown && (
            <div
              className="
            absolute right-0 mt-14 w-40
            bg-[#020617]
            border border-white/10
            rounded-xl shadow-2xl overflow-hidden
            z-50
          "
            >
              <Link to="/mentormaindashboard">
            <div className="px-4 py-2 text-sm text-slate-200 hover:bg-white/10 transition">
              Home
            </div>
          </Link>

              <button
                onClick={handleLogout}
                className="flex items-center gap-2 w-full px-4 py-2 text-sm font-medium text-red-400 hover:bg-white/10 transition"
              >
                <LogOutIcon size={16} /> Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>

  );
},
  // Custom comparison to prevent unnecessary re-renders
  (prevProps, nextProps) => {
    return prevProps.toggleSidebar === nextProps.toggleSidebar &&
      prevProps.isMobile === nextProps.isMobile;
  });

export default MentorHeader;